<template>
  <div class="custom-locale-control-frequency-container">
    <div class="frequency-control">
      <el-date-picker
        v-model="dateList"
        type="daterange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        size="small"
      />
      <el-button type="primary" @click="searchFrequency"
        size="small" :loading="searchLoading"
      >查询</el-button>
    </div>
    <div class="frequency-content">
      <FrequencyChart
        :showFlag="showFlag"
        :dataList="dataList"
      ></FrequencyChart>
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';

import FrequencyChart from './components/FrequencyChart';


import {
  getExposurePolygonByRegionAndDate,
} from '@/api/UserWorkspaceDataApi';

// props
const props = defineProps({
  showFlag: { type: Boolean, defalut: false, },
  layer: { type: Object, },
  data: { type: Array, },
});
// emit
const emit = defineEmits([
  'frequencyDataChange',
]);
const dateList = ref([ dayjs(new Date()).add(-7, 'day') , new Date()]);

const dataList = ref(props.data || []);

const searchLoading = ref(false);
const searchFrequency = ()=>{
  if(dateList.value.length < 2){
    message('请选择日期', 2);
    return;
  }
  const layer = props.layer,
        geojson = layer.toGeoJSON();
    
  searchLoading.value = true;
  getExposurePolygonByRegionAndDate({
    st: dayjs(dateList.value.at(0)).format('YYYY-MM-DD'),
    et: dayjs(dateList.value.at(1)).format('YYYY-MM-DD'),
    geometry: JSON.stringify(geojson['geometry'] || geojson),
  }).then(res=>{
    if(res.data.code == 1004){
      dataList.value = res.data.dataList;
      emit('frequencyDataChange', res.data.dataList);
    }
    searchLoading.value = false;
  }).catch(err=>{
    searchLoading.value = false;
    console.log(err);
  });

};

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  nextTick(()=>{
    if(dataList.value.length == 0){
      searchFrequency()
    }
  })
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.custom-locale-control-frequency-container{
  .frequency-content{
    height: 300px;
    width: 100%;
    min-width: 640px;
  }
}
</style>